import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { InputNumber } from "primereact/inputnumber";
import classNames from "classnames";

export default function P410Dialog({ dialog, setDialog, setsubmitForm, submitted }) {
    const [data, setData] = useState({
        itemNo: "",
        itemType: "",
        itemDesc: "",
        itemWeight: "",
    });

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };

    useEffect(() => {
        if (dialog.action === "EDIT") {
            setData({
                itemNo: dialog.data.itemNo,
                itemType: dialog.data.itemType,
                itemDesc: dialog.data.itemDesc,
                itemWeight: dialog.data.itemWeight,
            });
        } else {
            setData({ ...data, itemNo: dialog.data.itemNo });
        }
    }, [dialog]);
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button
                    // label={dialog.action}
                    label={"บันทึก"}
                    icon="pi pi-save"
                    onClick={() => setsubmitForm(data)} autoFocus className="p-button p-button-success" />
                <Button label="ยกเลิก" icon="pi pi-times" onClick={() => setDialog(false)} className="p-button-danger p-button" />
            </div>
        );
    };

    const onHide = () => {
        setDialog(false);
    };
    return (
        <>
            <Dialog header="เพิ่ม/แก้ไข รายละเอียดของรายการที่ประเมิน" visible={dialog.dialog} style={{ width: "45vw" }} className="p-fluid ___widthDialog" footer={renderFooter()} onHide={() => onHide()} blockScroll={true} maximizable={true}>
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-col-12">
                        <label>ลำดับ</label>
                        <div className="p-inputgroup">
                            <InputText value={data.itemNo} onChange={(e) => onInputTextChange(e, "criteriaDesc")} maxLength="5" disabled placeholder="กรุณาระบุ ลำดับ" />
                            {/* {submitted && !formObject.criteriaNo && validateInputText("criteriaNo", "ชื่อ-นามสกุล")}{" "} */}
                        </div>
                    </div>
                    <div className="p-col-12">
                        <label>ประเภทรายการ</label>
                    </div>
                    <div className="p-col-3">
                        <div className="p-field-radiobutton">
                            <RadioButton inputId="itemType_1" name="itemType_1" value="H" checked={data.itemType === "H" ? true : false} onChange={(e) => onInputTextChange(e, "itemType")} className={classNames({ "p-invalid": !data.itemType })} />
                            <label htmlFor="option1">หัวข้อ</label>
                        </div>
                    </div>
                    <div className="p-col-4">
                        <div className="p-field-radiobutton">
                            <RadioButton inputId="itemType_2" name="itemType_2" value="D" checked={data.itemType === "D" ? true : false} onChange={(e) => onInputTextChange(e, "itemType")} className={classNames({ "p-invalid": !data.itemType })} />
                            <label htmlFor="option1">รายการที่ประเมินผล</label>
                        </div>
                    </div>
                    <div className="p-col-12">{submitted && !data.itemType && validateInputText("itemType", "ประเภทรายการ")}</div>

                    <div className="p-col-12">
                        <label>ชื่อรายการ</label>
                        <InputText className={submitted && !data.itemDesc ? "p-invalid" : ""} value={data.itemDesc} maxLength="500" placeholder="กรุณาระบุ ชื่อรายการ" onChange={(e) => onInputTextChange(e, "itemDesc")} />
                        {submitted && !data.itemDesc && validateInputText("itemDesc", "ชื่อรายการ")}
                    </div>
                    <div className="p-col-12">
                        <label>นำ้หนัก</label>
                        <InputNumber
                            className={submitted && !data.itemWeight ? "p-invalid" : ""}
                            placeholder="น้ำหนัก"
                            inputId="itemWeight"
                            value={data.itemWeight}
                            onValueChange={(e) => onInputTextChange(e, "itemWeight")}
                            mode="decimal"
                            useGrouping={false}
                            max={99999}
                            minFractionDigits={2}
                            maxFractionDigits={2}
                        />
                        {submitted && !data.itemWeight && validateInputText("itemWeight", "น้ำหนัก")}
                    </div>
                </div>
            </Dialog>
        </>
    );
}
